import changeDriveFileName from '@/requests/cloud-storage/changeDriveFileName';
import formatTimestamp from '@/utils/generation/formatTimestamp';
import getExtensionFromResultType from '@/utils/generation/getExtensionFromResultType';

export interface RenamedDriveFile {
  filename: string;
  presetName: string;
}

/**
 * Builds the human-readable filename (e.g. `"Preset Name - Jan 25, 2.30 PM.png"`)
 * and, when `driveUid` is provided, renames the file on Drive so the name
 * persists across refreshes. Drive rename failures are swallowed — they are
 * non-critical and must not break the generation flow.
 */
const renameDriveFile = async ({
  driveUid,
  presetTitle,
  resultType,
  timestamp,
}: {
  driveUid?: string;
  presetTitle: string;
  resultType: string;
  timestamp: number;
}): Promise<RenamedDriveFile> => {
  // Create filename with extension: "Preset Name - Jan 25, 2:30 PM.png"
  const presetName = presetTitle || 'Generated';
  const extension = getExtensionFromResultType(resultType);
  const filename = `${presetName} - ${formatTimestamp(timestamp)}.${extension}`;

  // Rename file on Drive so name persists after refresh
  if (driveUid) {
    try {
      await changeDriveFileName({
        id: driveUid,
        name: filename,
      });
    } catch {
      // Failed to rename file on Drive - non-critical
    }
  }

  return { filename, presetName };
};

export default renameDriveFile;
